import { styled, Text, useTranslation } from '@obvio/app'
import { Button, Submit, useFormContext } from '@obvio/ui'

import type { ReactElement } from 'react'

const Wrap = styled.div`
  display: flex;
  justify-content: space-between;
  text-align: left;
  align-items: center;
  width: 100%;
  > span {
    max-width: 20rem;
    line-height: 170%;
  }
`

export function FormContinue(): ReactElement {
  const { t } = useTranslation()
  const { totalPages, activePage, prevPage } = useFormContext()
  const isLastPage = activePage === totalPages - 1
  return (
    <Wrap>
      {activePage === 1 ? (
        <Text tag="span">{t('joinForm.addArtworkInfo')}</Text>
      ) : (
        <Button kind="secondary" onClick={prevPage}>
          GO BACK
        </Button>
      )}
      <Submit>
        {t(isLastPage ? 'label.formSubmit' : 'label.formNextStep')}
      </Submit>
    </Wrap>
  )
}
